import React, { useEffect, useState } from 'react';
import { Col, Row, Collapse, Form, Input, Select } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import FilterContainer from '../../../../components/FilterContainer';
import { ApplicationState } from '../../../../store';
import {
  loadRequest,
  filterTracking,
  clearFilterTracking,
} from '../../../../store/ducks/tracking/actions';
import CollapseTitle from '../../../../components/TitleCollapseFilter';
import FilterBtn from '../../../../components/FilterBtn';
import ClearFilterBtn from '../../../../components/ClearFilterBtn';
import CollapseFilter from '../../../../components/CollapseFilter';
import serviceListaDepositantesTracking from '../../services/listaDepositantesTracking';
import SelectCidade from '../../../../components/SelectCidade';
import mask from '../../../../utils/mask';
import TextFilter from '../../../../components/TextFilter';

const { Panel } = Collapse;

type PropsDepositates = {
  codigo: number;
  nome: string;
  cnpj: string;
};

type PropsStatus = {
  codigo: string;
  nome: string;
};

type Cidade = {
  key: string;
  value: string;
};

const Filter: React.FC = () => {
  const dispatch = useDispatch();
  const pagCurrent = useSelector((state: ApplicationState) => state.Tracking.pagination.current);
  const [filter, setFilter] = useState<object | undefined | any>();
  const inscricoes = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const cd = useSelector((state: ApplicationState) => state.auth.cddAtivo?.codCdd) as number;
  const [cidade, setCidade] = useState<Cidade>();
  const status: PropsStatus[] = [
    { codigo: 'AE', nome: 'Aguardando expedição' },
    { codigo: 'ET', nome: 'Em transito' },
    { codigo: 'CC', nome: 'Chegada ao cliente' },
    { codigo: 'EF', nome: 'Entrega finalizada' },
  ];
  const [listaDepositantesTracking, setListaDepositantesTracking] = useState<PropsDepositates[]>(
    []
  );

  useEffect(() => {
    serviceListaDepositantesTracking.listaDepositantesTracking(inscricoes).then((response) => {
      setListaDepositantesTracking(response.data?.destinatarios);
    });
  }, [inscricoes]);

  const clearFilter = () => {
    dispatch(clearFilterTracking());

    localStorage.removeItem(`notaFiscal${window.location.pathname}`);
    localStorage.removeItem(`cidade${window.location.pathname}`);
    localStorage.removeItem(`cliente${window.location.pathname}`);
    localStorage.removeItem(`status${window.location.pathname}`);

    setCidade({} as Cidade);
    localStorage.removeItem(window.location.pathname + `valuesFilter`);
    dispatch(loadRequest({}, inscricoes, cd));
  };

  const onFilter = (values: any) => {
    Object.keys(values).forEach((key) => {
      if (values[key] === undefined || values[key] === null || values[key] === '') {
        delete values[key];
      }
    });

    localStorage.setItem(
      window.location.pathname + 'valuesFilter',
      JSON.stringify({
        numNota: values?.numNota && Number(values?.numNota),
        cidadeDestino: cidade?.key && Number(cidade?.key),
        cidadedeorigem: values?.cidadedeorigem,
        destinatario: values?.cliente && Number(values?.cliente),
        codDestinario: values?.codDestinario,
        status: values?.status && values?.status?.toString(),
      })
    );

    setFilter({
      numNota: values?.numNota && Number(values?.numNota),
      cidadeDestino: cidade?.key && Number(cidade?.key),
      destinatario: values?.cliente && Number(values?.cliente),
      status: values?.status && values?.status?.toString(),
    });
  };

  const localStorageItensPersist: any = JSON.parse(
    localStorage.getItem(window.location.pathname + `valuesFilter`) || '{}'
  );

  return (
    <CollapseFilter
      filter={filter}
      pagination={pagCurrent}
      loadRequest={loadRequest}
      saveFilter={filterTracking}
      saveLocalStorage={'persist:Tracking'}
    >
      <Panel header={<CollapseTitle>Filtro</CollapseTitle>} key="1">
        <FilterContainer
          onFilter={onFilter}
          initialValues={{
            ...localStorageItensPersist,
          }}
        >
          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <Form.Item name="numNota" label={<TextFilter>Nº da NF</TextFilter>}>
                <Input type="number" />
              </Form.Item>
            </Col>

            <Col md={6} sm={24} xs={24}>
              <Form.Item name="cidade" label={<TextFilter>Cidade destinatário</TextFilter>}>
                <SelectCidade setProps={setCidade} />
              </Form.Item>
            </Col>

            <Col md={6} sm={24} xs={24}>
              <Form.Item name="cliente" label={<TextFilter>Cliente destinatário</TextFilter>}>
                <Select
                  placeholder="Selecione o cliente"
                  showSearch
                  filterOption={(inputValue, option) =>
                    (option?.children ?? '')
                      .toString()
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  }
                >
                  {listaDepositantesTracking?.map((item) => (
                    <Select.Option key={item.codigo} value={item?.codigo}>
                      {item.nome}
                      <br />
                      {mask('cpfCnpj', item.cnpj)}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TextFilter>Status</TextFilter>} name="status">
                <Select placeholder="Selecione o status">
                  {status?.map((item) => (
                    <Select.Option key={item.codigo} value={item.codigo}>
                      {item.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24} justify="end">
            <Col md={6} sm={24} xs={24}>
              <ClearFilterBtn onClick={clearFilter}>Limpar filtros</ClearFilterBtn>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <FilterBtn>Filtrar</FilterBtn>
            </Col>
          </Row>
        </FilterContainer>
      </Panel>
    </CollapseFilter>
  );
};

export default Filter;
